
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.333 4c0-.736.597-1.333 1.333-1.333h10.667c.736 0 1.333.597 1.333 1.333v8c0 .737-.597 1.334-1.333 1.334H2.666A1.333 1.333 0 011.333 12V4zm2.346 0l4.32 3.781 4.322-3.78H3.679zm9.654.886L8.439 9.17a.667.667 0 01-.878 0L2.666 4.886V12h10.667V4.886z","fill":"#A0AEC0"}})])
          )
        }
      }
    